import { scrollToTop } from "@faire/help-center-utils/lib/window";
import { useEffect } from "react";
export var useScrollToTopOnLoadEffect = function useScrollToTopOnLoadEffect(delay) {
  useEffect(function () {
    scrollToTop(delay);
  }, [delay]);
};